import { SET_CP_CONTACT_NUMBER } from "constants-lib/actionTypes"

export const setCPContactNumber = (contactNumber) => ({
  type: SET_CP_CONTACT_NUMBER,
  payload: contactNumber,
})
